import API_PUBLIC_SERVICE from './http';

const PREFIX = 'ranges';
const path = PREFIX;

const pagePath = '/health-plan';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'range',
      key: 'range',
      disablePadding: false,
      numeric: false,
      label: 'Tramo'
    },
    {
      id: 'coverage',
      key: 'coverage',
      disablePadding: false,
      numeric: false,
      label: 'Porcentaje'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      style: {
        width: '130px'
      },
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: value => value,
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false,
  ...pagesRoute
};

const InsuranceService = {
  ...API_PUBLIC_SERVICE,
  ...tableData,
  path
};

export default InsuranceService;
